import admin from "firebase/compat/app";
import "firebase/compat/storage";
import { getStorage, ref as storageRef, uploadString } from "firebase/storage";

const SPORTSBOX_SERVER =
  "https://sportsbox-server-pipeline-249376958558.us-central1.run.app";

export const videoService = {
  async addJsonToStorage({ videoId, data }) {
    try {
      // ——— UPLOAD JSON TO FIREBASE STORAGE ———
      const storage = getStorage();
      const filename = `${videoId.toLowerCase()}mp4_${videoId}_ai.json`;
      const fullPath = `swing_data/${videoId}/${filename}`;
      const fileRef = storageRef(storage, fullPath);
      const jsonString = JSON.stringify(data);
      await uploadString(fileRef, jsonString, "raw", {
        contentType: "application/json",
      });
      console.log(`Uploaded analysis JSON to ${fullPath}`);
    } catch (err) {
      console.error("Error adding JSON to storage:", err);
    }
  },

  async sendAnalysisVideoRequest({ videoId, videoUrl, metaData }) {
    try {
      const requestBody = {
        videoUrl: videoUrl,
        metadataMap: metaData,
        annotatedSwingPosition: {},
        addonSubscriptions: [],
      };

      const response = await fetch(`${SPORTSBOX_SERVER}/v1/analyze`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "customerId": "sportsbox-internal-server",
          "sportsboxApiKey": "sbx_7c46444a532c462fa3ca29a2ea4fbafd",
        },
        body: JSON.stringify(requestBody),
      });
      const data = await response.json();
      const result = data.result;
      await videoService.addJsonToStorage({ videoId, data: result });
      await admin.firestore().collection("videos").doc(videoId).update({
        analyzed: true,
        analysisPlatform: "Server",
      });
      return result;
    } catch (err) {
      console.error("Analysis request failed:", err);
    }
  },
};
